import React, { useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import { getOtpMode } from '../../store/users';
import { useSelector } from 'react-redux';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const ChangePasswordBox = ({ onNext, onBack, buttonName }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  const otpModeSelected = useSelector(getOtpMode)

  const handleChange = (e) => {
    // setPassword(e.target.value);
    const { value } = e.target;
    let isValid = true;

    if (otpModeSelected === 'Email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      isValid = emailRegex.test(value);
    } else if (otpModeSelected === 'Mobile') {
      const mobileRegex = /^[0-9]{10}$/;
      isValid = mobileRegex.test(value);
    }

    setPassword(value);
    setError(!isValid);
  };

  const handleSubmit = () => {
    if (password) {
      onNext();
    }
  };

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
        <Button
          variant="outlined"
          color="secondary"
          sx={{
            border: 'none',
            '&:hover': {
              border: 'none',
            }
          }}
          onClick={onBack}
        >
          <ArrowBackIcon /> Back
        </Button>
      </Box>
      <Typography variant="h5" sx={{ fontWeight: '600', paddingBottom: "5px" }}>{buttonName}?</Typography>
      <Typography variant="h6" sx={{ marginTop: "3px", paddingBottom: "5px" }}>Please Enter {otpModeSelected}</Typography>
      <TextField
        value={password}
        onChange={handleChange}
        label={`Please Enter ${otpModeSelected}`}
        variant="outlined"
        fullWidth
        error={error}
        helperText={error ? `Invalid ${otpModeSelected} Format` : ''}
        sx={{ mt: 2, paddingBottom: "5px" }}
      />
      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{
          mt: 2,
          backgroundColor: "#f5365c",
          borderColor: "#f5365c",
          '&:hover': {
            backgroundColor: '#f5365c',
            color: 'white',
            border: 'none',
          }
        }}
        onClick={handleSubmit}>
        Submit
      </Button>


    </Box>
  );
};

export default ChangePasswordBox;
